import React, { useState } from "react";

import ArrowLeft from "../../../../../../../../features/cards-v2/components/actions/icons/ArrowLeft";
import ArrowRight from "../../../../../../../../features/cards-v2/components/actions/icons/ArrowRight";
import {
  CarouselContainer,
  CarouselImage,
  CarouselImages,
  SliderActionsContainer,
  SliderArrowContainer,
  SliderArrowsContainer,
  SliderContainer,
  SliderHeading,
  SliderProgressBar,
  SliderProgressBarContainer,
} from "./styles";
import { NUMBER_OF_IMAGES_PER_VIEW } from "./defaults";
import { IMAGE_SLIDER_PROP } from "../../../../../settings/features/image-slider/defaults";
import { useImageSliderStore } from "../../../../../../../../stores/use-image-slider-store";

const Carousel = ({ data, isPreview, canEdit }) => {
  const { image: selectedImage, setImage } = useImageSliderStore((state) => ({
    image: state.image,
    setImage: state.setImage,
  }));
  const [startIndex, setStartIndex] = useState(0);

  const numberOfImagesPerSlide = NUMBER_OF_IMAGES_PER_VIEW[isPreview];

  const nextSlide = () =>
    setStartIndex((prevIndex) => (prevIndex + 1) % data.images.length);

  const previousSlide = () =>
    setStartIndex(
      (prevIndex) => (prevIndex - 1 + data.images.length) % data.images.length
    );

  const isFirstImageVisible = startIndex === 0;

  const isLastImageVisible =
    startIndex >= data.images.length - numberOfImagesPerSlide ||
    data.images.length <= numberOfImagesPerSlide;

  const calculateProgressWidth = () => {
    const totalImages = data.images.length;
    const currentProgress =
      ((startIndex + numberOfImagesPerSlide) / totalImages) * 100;

    return currentProgress > 100 ? 100 : currentProgress;
  };

  return (
    <SliderContainer>
      {data.hasImagesTitle && (
        <SliderHeading
          textAlign={
            data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS][
              IMAGE_SLIDER_PROP.TITLE_ALIGNMENT
            ]
          }
        >
          {data.title}
        </SliderHeading>
      )}
      <CarouselContainer>
        <CarouselImages
          startIndex={startIndex}
          numberOfImagesPerSlide={numberOfImagesPerSlide}
        >
          {data.images.map((image, index) => (
            <CarouselImage
              key={index}
              src={image.link}
              position={image?.focalPoint}
              showPointer={image.linkToPage?.link || isPreview || canEdit}
              alt={`Slide ${index}`}
              onClick={() => {
                if (isPreview) return;

                if (image.linkToPage?.link && !canEdit) {
                  window.open(
                    image.linkToPage.link,
                    image.linkToPage.newTab ? "_blank" : "_top"
                  );
                }

                if (canEdit) {
                  if (image.id === selectedImage?.id) {
                    setImage(undefined);
                  } else setImage(image);
                }
              }}
              borderRadius={
                data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS][
                  IMAGE_SLIDER_PROP.BORDER_RADIUS
                ]
              }
              numberOfImagesPerSlide={numberOfImagesPerSlide}
            />
          ))}
        </CarouselImages>
      </CarouselContainer>
      <SliderActionsContainer>
        <SliderArrowsContainer>
          <SliderArrowContainer
            onClick={previousSlide}
            disabled={isFirstImageVisible}
          >
            <ArrowLeft />
          </SliderArrowContainer>
          <SliderProgressBarContainer>
            <SliderProgressBar width={calculateProgressWidth()} />
          </SliderProgressBarContainer>
          <SliderArrowContainer
            onClick={nextSlide}
            disabled={isLastImageVisible}
          >
            <ArrowRight />
          </SliderArrowContainer>
        </SliderArrowsContainer>
      </SliderActionsContainer>
    </SliderContainer>
  );
};

export default Carousel;
